<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card flat color="transparent">
          <v-card-text class="text-center">
            <h1 class="display-2 py-4">Welcome to Context</h1>
            <p class="title pb-4">Sign up or log in to continue</p>
            <auth
              id="mainAuth"
              @signInStart="signingIn = true"
              @signInSuccess="signingIn = false"
              @signInError="signingIn = false"
            ></auth>
          </v-card-text>
        </v-card>
        <!-- <v-layout v-else column align-center>
          <span class="title text-center">Pick a context to explore from your sidebar </span>
          <div>or</div>
          <v-btn v-if="workspaces.length == 1" @click="createContext">Create a new Context</v-btn>
          <v-menu offset-y v-else>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                Create a new Context
              </v-btn>
            </template>
            <v-list>
              <v-subheader>Choose a workspace to put it in</v-subheader>
              <v-list-item
                v-for="space in workspaces"
                :key="space.id"
                @click="createContext(space.id)"
              >
                <v-list-item-title>{{ space.profile.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-layout> -->
      </v-flex>
    </v-layout>
    <v-overlay :value="signingIn || fetchingData" style="text-align: center;">
      <v-progress-circular indeterminate></v-progress-circular>
      <div v-if="fetchingData">Getting your stuff...</div>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import Auth from '@/components/Auth';
export default {
  components: { Auth },
  data() {
    return {
      signingIn: false,
      fetchingData: false
    };
  },
  mounted() {
    // if (this.isUser) {
    //   this.toggleSidebar(true);
    // }
  },
  watch: {
    fetchingUserData: function(n, o) {
      console.log(n, o);
      if (n && !o) {
        this.fetchingData = true;
      }
      if (o && !n) {
        this.fetchingData = false;
        this.$router.push({ name: 'dashboard' });
      }
    }
    // isUser: function(n, o) {
    //   if (n && !o) {
    //     this.toggleSidebar(true);
    //   } else if (!n && o) {
    //     this.toggleSidebar(false);
    //   }
    // }
  },
  computed: {
    ...mapGetters('auth', ['isUser']),
    ...mapGetters('workspaces', ['workspaces']),
    ...mapState('auth', ['fetchingUserData'])
  },
  methods: {
    ...mapMutations('components/explorerSidebar', ['toggleSidebar']),
    ...mapActions('workspaces', ['createNewWorkspace']),
    ...mapActions('context', ['creatNewContext']),
    async createContext(spaceId = false) {
      //  Either we passed in an ID, or we just pick the first workspace.
      const newId = await this.creatNewContext({
        workspaceId: spaceId ? spaceId : this.workspaces[0].id
      });
      this.$nextTick(() => {
        this.$router.push({ name: 'context', params: { contextId: newId } });
      });
    }
  }
};
</script>

<style></style>
